import * as _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useFormState } from "../../components/main/ActivationForm/Context/ActivationFormContext";
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import Notifier from '../../common/Notifier/Notifier';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import SendAction from '../../CourierService/SendAction';

const ThrottlingBanner = () => {
  // eslint-disable-next-line react/prop-types
  const { t } = useTranslation();
  const { api403Error, user_session, api403ErrorMsg } = useFormState();

  if (api403Error === false) return null;

  SendAction({ action: 'Error occurred due to Bad request', value: 'Reload signup page', userSession: user_session });
  if (_.includes(api403ErrorMsg, 'Too many requests') || _.includes(api403ErrorMsg, 'Retry request after')) {
    // eslint-disable-next-line react/jsx-filename-extension
    return <Notifier type="error" message={t('throttleBanner.api403Error', 'Forbidden')} position="api403Error" />;
  }

  return <Notifier type="error" message={t('throttleBanner.api403Error', 'Forbidden')} position="NetworkError" />;
};

export default ThrottlingBanner;
